module.exports = __webpack_public_path__ + "img/zhoutingting.556537b0.jpg";